import moment from 'moment';
import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import DataReactTableAppointmentsPatient from './DataReactTableAppointmentsPatient';
import Spinner from 'react-bootstrap/Spinner';

const PatientsAppointments = ({ id_patient }) => {
    const [patientAppointments, setPatientAppointments] = useState(null);
    const [patient, setPatient] = useState(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const loadSearchPatient = async () => {
            let dataSend = {
                num_documento: parseInt(id_patient)
            }
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        setPatient(data.contenido[0]);
                        loadAppointmentsFromPatient(data.contenido[0].id_historia);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        const loadAppointmentsFromPatient = async (id_historia) => {
            setLoad(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/citas-por-paciente?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (typeof data !== '[]') {
                        setPatientAppointments(data);
                    }
                    setLoad(false);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        loadSearchPatient();
    }, [])

    const reactTableDataAppointments = {
        tableHeaderData: [{
            Header: 'ID',
            accessor: 'id_cita',
            //disableGlobalFilter: true,
        },
        {
            Header: 'FECHA Y HORA',
            accessor: 'inicio',
            Cell: row => (
                <div>
                    <label>
                        {moment(row.value).format('DD-MM-YYYY hh:mm')}
                    </label>
                </div>
            )
        },
        {
            Header: 'SERVICIO',
            accessor: 'title', 
        },
        {
            Header: 'ESTADO',
            accessor: 'cancelada', 
            Cell: row => (
                <div>
                    {row.cell.row.original.cancelada === true ? 'CANCELADA' : 'REALIZADA'}
                </div>
            )
        },
        ],
        tableRowsData: patientAppointments
    };

    const LoadInfo = () => {
        return (<DataReactTableAppointmentsPatient
            reactTableData={reactTableDataAppointments}
        />)
    }


    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>CITAS</b></h4>
                                </div>
                            </div>
                        </Row>
                        <Row>
                        <Col>
                                {
                                    load ?
                                        <div className="text-center">
                                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                        </div>
                                        : patientAppointments ?
                                            <LoadInfo />
                                            :
                                            <div className="info-empty-profile">
                                                <h5>No se ha generado aún ninguna cita</h5>
                                            </div>

                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default PatientsAppointments